import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { merge } from 'lodash'
import { emptySAR } from '~bank-bsa-reporting/constants'
import { SarDetailsEditPayload, SarEdit } from '~bank-bsa-reporting/types/sar'

import { payloadToFormMapper } from '../../routes/SAR/Manage/helpers/payloadMapper'

export const useGetEditSAR = (id: number) => {
  const { data: initialSAR, isFetching } = useQuery<SarDetailsEditPayload>({
    queryKey: ['sar-edit', id],
    queryFn: () =>
      id ? Request.post(Request.urls.bank.sarEditMode, { id }) : Request.post(Request.urls.bank.sarCreateMode),
    placeholderData: keepPreviousData
  })

  let data: SarEdit

  if (id && initialSAR) {
    data = payloadToFormMapper(initialSAR.form)
  } else {
    data = merge({ ...emptySAR }, initialSAR?.form)
  }

  return {
    isFetching,
    data
  }
}
